import { render, staticRenderFns } from "./LayerLegend.vue?vue&type=template&id=220797d6&"
import script from "./LayerLegend.vue?vue&type=script&lang=js&"
export * from "./LayerLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports